// Replace %{name} tokens in a Rails I18n template with runtime values. The
// onboarding copy varies by the communication channel (email vs mobile) which
// is only known client-side, so the server ships templates with placeholders
// and we fill them in here.
//
// Values are inserted verbatim, so any value placed inside an HTML template
// string (rendered via dangerouslySetInnerHTML) MUST be escaped with
// escapeHtml first.
export function interpolate(template, vars = {}) {
  return Object.entries(vars).reduce(
    (result, [key, value]) =>
      result.split(`%{${key}}`).join(value == null ? '' : value),
    template || '',
  );
}

// Minimal HTML escaping for user-supplied values interpolated into an HTML
// template string before dangerouslySetInnerHTML.
export function escapeHtml(value) {
  return String(value == null ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
